import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import React, { memo } from 'react'

export type Theme = typeof theme

export const theme = {
  colors: {
    variants: {
      neutralLight4: '#FFFFFF',
      neutralLight3: '#E9E9E9',
      neutralDark2: '#414141',
      neutralDark1: '#000000',
      primaryLight1: '#076AB3',
    },
  },
  fontFamily: {
    heading: "'Poppins', sans-serif",
  },
}

export const ThemeProvider = memo(function ThemeProvider({ children }) {
  return <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
})
